import SuccessfulCompletion1 from '@/assets/successfulCompletion1.png';
import SuccessfulCompletion2 from '@/assets/successfulCompletion2.png';
import { getRandomInteger } from '@/utils/getRandomInteger';

export const SuccessfulCompletion = getRandomInteger(0, 1)
  ? SuccessfulCompletion1
  : SuccessfulCompletion2;
